/**
 * Хранение сессии на устройстве.
 *
 * Ключ `fitness_token` — контракт с бэкендом: страница входа по magic-link
 * (`backend/routers/auth.py`, `TOKEN_STORAGE_KEY`) кладёт токен именно сюда.
 * Менять имя можно только вместе с ней.
 */

const TOKEN_KEY = 'fitness_token'

/**
 * localStorage может быть недоступен: приватный режим Safari, отключённые
 * данные сайта, встроенный webview с урезанными правами. Приложение обязано
 * пережить это — в худшем случае вход придётся повторять каждый запуск,
 * но падать посреди тренировки оно не должно.
 */
function safeStorage(): Storage | null {
  try {
    const probe = '__probe__'
    window.localStorage.setItem(probe, '1')
    window.localStorage.removeItem(probe)
    return window.localStorage
  } catch {
    return null
  }
}

/** Запасное хранилище на время сессии, если localStorage закрыт. */
let memoryToken: string | null = null

export function getToken(): string | null {
  const store = safeStorage()
  if (store) {
    return store.getItem(TOKEN_KEY) ?? memoryToken
  }
  return memoryToken
}

export function setToken(token: string): void {
  memoryToken = token
  safeStorage()?.setItem(TOKEN_KEY, token)
}

export function clearToken(): void {
  memoryToken = null
  safeStorage()?.removeItem(TOKEN_KEY)
}

export function hasToken(): boolean {
  return Boolean(getToken())
}
